import { render, staticRenderFns } from "./BountyDetails.vue?vue&type=template&id=5203205f&scoped=true"
import script from "./BountyDetails.vue?vue&type=script&lang=js"
export * from "./BountyDetails.vue?vue&type=script&lang=js"
import style0 from "./BountyDetails.vue?vue&type=style&index=0&id=5203205f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203205f",
  null
  
)

export default component.exports